import { HStack, Text } from '@chakra-ui/react';
import React, { FC } from 'react';

import { Icon } from '@app/components/Icon';
import { TokenIcon } from '@app/components/TokenIcon';
import { Pair } from '@app/types/pool';

import s from './PoolTokensCell.module.scss';
import { getSymbol } from '@app/helpers/symbol';

interface Props {
  token0: Pair['token0'];
  token1: Pair['token1'];
}

export const PoolTokensCell: FC<Props> = ({ token0, token1 }) => {
  const token0Symbol = getSymbol(token0.symbol);
  const token1Symbol = getSymbol(token1.symbol);

  return (
    <HStack gap={0} className={s.root}>
      <TokenIcon symbol={token0Symbol} />
      <TokenIcon symbol={token1Symbol} sx={{ transform: 'translateX(-6px)' }} />
      <Text ml="24px">{token0Symbol}</Text>
      <Text>-</Text>
      <Text>{token1Symbol}</Text>
    </HStack>
  );
};
